/**
 * Owner: Masa Bayu
 * File: LiveComingPanel.tsx
 * Date:Time: 2026-09-18 10:49
 * Description: UI-06C Arena Live placeholder — honest unavailable until Lanjut 06C.
 */

export interface LiveComingPanelProps {
  readonly onNavigate: (path: string) => void;
}

export function LiveComingPanel({ onNavigate }: LiveComingPanelProps) {
  return (
    <section
      className="route-panel live-coming"
      data-ui06-surface="live"
      data-live-state="unavailable"
      aria-labelledby="live-coming-title"
    >
      <h2 id="live-coming-title">Arena Live</h2>
      <p>
        Live sessions bound to publications land here. Stage · Live Chat · post-live Circle handoff
        ship in UI-06C — this entry is reserved, not a marketplace shell.
      </p>
      <p role="status" className="live-coming__status">
        Surface state: unavailable · Discussion ≠ entitlement
      </p>
      <div className="qx-cta-group" role="group" aria-label="Arena Live exits">
        <button
          type="button"
          className="qx-cta qx-cta--accent"
          onClick={() => {
            onNavigate('/circle');
          }}
        >
          Open QXCircle
        </button>
        <button
          type="button"
          className="qx-cta qx-cta--secondary"
          onClick={() => {
            onNavigate('/');
          }}
        >
          Back to Home
        </button>
      </div>
    </section>
  );
}
